const comments = [
  {
    name: '吃瓜第一线',
    time: '2小时前',
    text: '51吃瓜网真的太方便了！以前找入口经常找不到，现在直接收藏这个页面，每天打开就能看到最新动态。更新速度确实快，比我自己刷微博还快，强烈推荐给所有吃瓜爱好者！',
    likes: '1286',
  },
  {
    name: '娱乐圈观察家',
    time: '5小时前',
    text: '用了半年多了，从最开始的小站到现在功能越来越完善。入口稳定，内容全面，手机端体验也很流畅。希望能一直保持这个更新频率，已经成为我的每日必刷网站了。',
    likes: '963',
  },
  {
    name: '八卦小能手',
    time: '8小时前',
    text: '作为一个资深吃瓜群众，试过很多类似的网站，51吃瓜网是目前综合体验最好的。资讯聚合做得很到位，分类清晰，而且没有乱七八糟的弹窗广告，浏览体验很舒服。',
    likes: '751',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[800px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">瓜友热评</h2>
        <p className="text-sm text-foreground-500 text-center mb-10">听听百万瓜友的真实评价</p>

        <div className="space-y-4">
          {comments.map((comment) => (
            <div key={comment.name} className="bg-background-100 rounded-xl p-5 md:p-6">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-sm font-bold text-accent-600">{comment.name.charAt(0)}</span>
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">{comment.name}</div>
                  <div className="text-xs text-foreground-400">{comment.time}</div>
                </div>
              </div>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-3">{comment.text}</p>
              <div className="flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-thumb-up-line"></i>
                <span>{comment.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}